import React from 'react';
import { Shield, Target, Users, Award } from 'lucide-react';

const About = () => {
  const values = [
    {
      icon: Shield,
      title: 'Trust & Transparency',
      description: 'Complete transparency in all investments with regular reporting and open communication'
    },
    {
      icon: Target,
      title: 'Strategic Excellence',
      description: 'Data-driven strategies backed by deep market analysis and proven methodologies'
    },
    {
      icon: Users,
      title: 'Client-Centric',
      description: 'Customized investment solutions designed around your unique financial objectives'
    },
    {
      icon: Award,
      title: 'Proven Track Record',
      description: 'Consistent performance delivering superior returns across multiple market cycles'
    }
  ];

  return (
    <section id="about" className="section-dark">
      <div className="container-standard">
        <div className="about-content">
          <div className="about-text-section">
            <h2 className="section-title">About Infinity Capital</h2>
            <div className="about-text">
              <p className="body-large">
                For over 15 years, Infinity Capital Inc. has been at the forefront of strategic investment management, helping clients build and preserve wealth through carefully curated opportunities across diverse sectors.
              </p>
              <p className="body-medium">
                Our team of seasoned investment professionals brings decades of combined experience in stock market trading, real estate development, technology venture capital, equipment financing, and energy sector investments. We combine traditional investment wisdom with cutting-edge analytics to identify opportunities that deliver exceptional risk-adjusted returns.
              </p>
              <p className="body-medium">
                With multi-million dollars in assets under management and a client retention rate exceeding 98%, we've built our reputation on delivering results that matter. Every investment decision is guided by rigorous due diligence, comprehensive risk assessment, and an unwavering commitment to our clients' financial success.
              </p>
            </div>
          </div>

          <div className="values-grid">
            {values.map((value, idx) => {
              const Icon = value.icon;
              return (
                <div key={idx} className="value-card">
                  <div className="value-icon">
                    <Icon size={28} />
                  </div>
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-description">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
